module.exports = __webpack_public_path__ + "img/202405_04.4b312582.jpg";